import { useTranslation } from 'react-i18next'

import AccentLabel, {
  type AccentLabelProps,
} from '~/components/common/labels/AccentLabel'
import { FormStatus, type SoapForm } from '~/types'

export interface FormStateLabelProps extends AccentLabelProps {
  form: SoapForm
}

const FormStateLabel = ({ form, ...rest }: FormStateLabelProps) => {
  const { t } = useTranslation('Common')

  const FormLabelMap = {
    [FormStatus.COMPLETE]: t('Common:COMPLETED'),
    [FormStatus.DUE]: t('Common:DUE_DATE'),
  }
  return (
    <AccentLabel
      colorVariant={
        form.status === FormStatus.COMPLETE ? 'completed' : 'warning'
      }
      name={FormLabelMap[form.status]}
      {...rest}
    />
  )
}

export default FormStateLabel
